export default "__VITE_ASSET__1bfSXUdn__"